module.exports = __webpack_public_path__ + "img/audio.387e1de7.png";